<template>
    <v-col cols="3" v-if="items && items.length > 0">
        <v-card :class="`article-table-of-contents`" :elevation="3">
            <v-treeview
                hoverable
                item-key="key"
                expand-icon="mdi-chevron-down"
                :open="open"
                :active="active"
                :items="items"
                activatable
            >
                <template v-slot:label="{ item, open }">
                    <table-of-contents-item :ref="item.key" :item="item" :open="open" />
                </template>
            </v-treeview>
        </v-card>
    </v-col>
</template>

<script>
import tableOfContentsManager from "src/components/common/table-of-contents/managers/tableOfContentsManager";
import TableOfContentsItem from "src/components/common/table-of-contents/TableOfContentsItem.vue";
import { EventBus } from "src/bus/eventBus";
import { isArray, last } from "lodash";
import scrollManager from "src/components/convention/managers/scrollManager";

export default {
    components: { TableOfContentsItem },
    props: ["article"],
    data() {
        return {
            items: [],
            open: [],
            active: [],
            observers: [],
        };
    },
    mounted() {
        this.items = tableOfContentsManager.getArticleItems(this.article);
        EventBus.$on("article-body:scrolled", selectedIds => {
            if (isArray(selectedIds) && selectedIds.length <= 4) {
                this.open = selectedIds;
                const lastId = last(selectedIds);
                this.setActive(lastId);
                this.$nextTick(() => this.checkPosition(lastId));
            }
        });
        setTimeout(() => {
            this.observeTitles(this.items);
        }, 1000);
    },
    watch: {
        article(_article) {
            this.items = tableOfContentsManager.getArticleItems(_article);
            this.cleanObservers();
            setTimeout(() => {
                this.observeTitles(this.items);
            }, 1000);
        },
    },
    methods: {
        observeTitles(items, pathIds = []) {
            return items.map(item => {
                const titleElement = document.getElementById(item.id);
                if (titleElement !== null) {
                    this.observers.push(
                        scrollManager.observeTitle(titleElement, () => {
                            EventBus.$emit("article-body:scrolled", [...pathIds, item.id]);
                        })
                    );
                }
                if (isArray(item.children) && item.children.length > 0) {
                    this.observeTitles(item.children, [...pathIds, item.id]);
                }
            });
        },
        checkPosition(key) {
            if (this.$refs[key]) {
                const element = this.$refs[key].$el;
                const elementRect = element.getBoundingClientRect();
                const parentRect = this.$el.children[0].getBoundingClientRect();
                const py1 = parentRect.y + 10;
                const py2 = parentRect.y + parentRect.height - 10;
                const y = elementRect.y;
                const isVisible = py1 <= y && py2 >= y;
                if (!isVisible) {
                    const delta = y - py1 - 50;
                    this.$el.children[0].scrollTo(0, this.$el.children[0].scrollTop + delta);
                }
            }
        },
        setActive(id) {
            this.active = [id];
        },
        cleanObservers() {
            this.observers.forEach(observer => observer.disconnect());
            this.observers = [];
        },
    },
    destroyed() {
        this.cleanObservers();
    },
};
</script>

<style lang="sass">
.article-table-of-contents
    transition: none !important
    position: sticky
    top: 100px

    .v-sheet.v-card
        max-height: calc(100vh - 220px)
        overflow: auto

    .v-treeview > .v-treeview-node
        & > .v-treeview-node__root
            border-bottom: 1px solid transparentize($color-secondary, .5)
        & > .v-treeview-node__children
            border-bottom: 1px solid transparentize($color-secondary, .5)

    .legend,
    .empty
        opacity: 0.3
        pointer-events: none
</style>
